<script>
	import '../../app.css';
	import { invalidate } from '$app/navigation';
	import { onMount } from 'svelte';
	import ToastService from '#lib/components/organisms/ToastSystem/ToastService.svelte';

	let { data, children } = $props();
	let { session, supabase } = $derived(data);

	onMount(() => {
		const { data } = supabase.auth.onAuthStateChange((_, newSession) => {
			if (newSession?.expires_at !== session?.expires_at) {
				invalidate('supabase:auth');
			}
		});

		return () => data.subscription.unsubscribe();
	});
</script>

{@render children?.()}
<ToastService />
